import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import Img1 from "../../../images/locationgcc/web/logo-1.webp";
import Img2 from "../../../images/locationgcc/web/logo-2.webp";
import Img3 from "../../../images/locationgcc/web/logo-3.webp";
import Img4 from "../../../images/locationgcc/web/logo-4.webp";
import Img5 from "../../../images/locationgcc/web/logo-5.webp";
import Img6 from "../../../images/locationgcc/web/logo-6.webp";
import Img7 from "../../../images/locationgcc/web/logo-7.webp";
import Img8 from "../../../images/locationgcc/web/logo-8.webp";
import Img9 from "../../../images/locationgcc/web/logo-9.webp";
import Img10 from "../../../images/locationgcc/web/logo-10.webp";
import Img11 from "../../../images/locationgcc/web/logo-11.webp";
import Img12 from "../../../images/locationgcc/web/logo-12.webp";
import Img13 from "../../../images/locationgcc/web/logo-13.webp";
import Img14 from "../../../images/locationgcc/web/logo-14.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Brand(props) {
  return (
    <div className="brandsol stack_web p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="my-auto text-center"
          >
            <h2>
              TekRevol’s Tech Stack For Developing Next-Gen Software Solutions
            </h2>
            <p>
              As one of the top web development companies in KSA, we know the
              importance of using cutting-edge technologies to provide clients
              with a competitive advantage in the market.
            </p>
            <div className="brand_box">
              <div className="brand_img">
                <LazyLoadImage
                  src={Img1}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img2}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img3}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img4}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img5}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img6}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img7}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img8}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img9}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img10}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img11}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img12}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img13}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img14}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Brand;
